import type { Accessor } from './function-types/accessor';

export function isFunction(func: unknown): func is Function {
  return typeof func === 'function';
}

export function isAccessor<Item, Value>(accessor: unknown): accessor is Accessor<Item, Value> {
  return isFunction(accessor) && accessor.length === 1;
}